import React, { Component } from 'react'
import { Row, Col, Card, CardHeader, CardBody, Table, FormGroup, Label, Input, Button, ButtonGroup } from 'reactstrap'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import CreatableSelect from '../Wps/CreatableSelect'
import { AvForm } from 'availity-reactstrap-validation'
import { ElementsFetchQuery, WeldersFetchQuery, WelderDefectivenessQuery } from './query'
import BlockWithLoader from '../Support/BlockWithLoader'
import { countPercent, InspectionTableHeaders, InspectionTableData } from './defectivness/'

function prepareFiltersFromUrl(search) {
  const parsed = queryString.parse(search)
  const filters = {}
  if (parsed.project_id) filters.project_id = Number(parsed.project_id)
  if (parsed.welder_ids) filters.welder_ids = parsed.welder_ids.split(',').map(Number)
  if (parsed.element_ids) filters.element_ids = parsed.element_ids.split(',').map(Number)
  if (parsed.date_from) filters.date_from = parsed.date_from
  if (parsed.date_to) filters.date_to = parsed.date_to
  if (parsed.date_type) filters.date_type = parsed.date_type
  return filters
}

class WelderDefectiveness extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    ProjectsList: PropTypes.array.isRequired,
    InspectionCategoryTypes: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    const filters = prepareFiltersFromUrl(props.location.search)
    this.state = {
      welders_list: [],
      projectElements: [],
      filters,
      data: [],
      loading: false,
    }
  }

  componentWillMount() {
    this.props.client.query({
      query: WeldersFetchQuery,
      fetchPolicy: 'network-only',
      variables: { filters: { permission_key: 'core.people.welder', anonymized: 'false' } }
    }).then(({ data }) => {
      this.setState({ welders_list: data.people.list })
    })

    const { filters } = this.state
    if (filters.project_id) {
      this.fetchProjectElements(filters.project_id)
    }

    if (filters.project_id || filters.welder_ids) {
      this.fetchData(filters)
    }
  }

  fetchProjectElements(project_id) {
    this.props.client.query({
      query: ElementsFetchQuery,
      fetchPolicy: 'network-only',
      variables: { parent_id: Number(project_id) }
    }).then(({ data }) => {
      this.setState({ projectElements: data.elements.list })
    })
  }

  fetchData(filters) {
    this.setState({ loading: true })
    this.props.client.query({
      query: WelderDefectivenessQuery,
      fetchPolicy: 'network-only',
      variables: {
        project_id: filters.project_id || null,
        project_ids: filters.element_ids && filters.element_ids.length > 0 ? filters.element_ids : null,
        with_children: true,
        welder_ids: filters.welder_ids && filters.welder_ids.length > 0 ? filters.welder_ids : null,
        date_from: filters.date_from || null,
        date_to: filters.date_to || null,
        date_type: filters.date_type || 'welding',
      }
    }).then(({ data }) => {
      this.setState({ data: data.welder_defectiveness || [], loading: false })
    }).catch(() => {
      this.setState({ loading: false })
    })
  }

  updateUrl(filters) {
    const params = {}
    if (filters.project_id) params.project_id = filters.project_id
    if (filters.welder_ids && filters.welder_ids.length > 0) params.welder_ids = filters.welder_ids.join(',')
    if (filters.element_ids && filters.element_ids.length > 0) params.element_ids = filters.element_ids.join(',')
    if (filters.date_from) params.date_from = filters.date_from
    if (filters.date_to) params.date_to = filters.date_to
    if (filters.date_type) params.date_type = filters.date_type
    this.props.history.replace(`${this.props.history.location.pathname}?${queryString.stringify(params)}`)
  }

  setFilter(patch) {
    const filters = { ...this.state.filters, ...patch }
    this.setState({ filters }, () => {
      this.updateUrl(filters)
      this.fetchData(filters)
    })
  }

  handleClearFilters = () => {
    const filters = {}
    this.setState({ filters, data: [], projectElements: [] }, () => {
      this.props.history.replace(this.props.history.location.pathname)
    })
  }

  handleProjectChange = (val) => {
    const filters = { ...this.state.filters, project_id: val ? val.id : null, element_ids: [] }
    this.setState({ filters, projectElements: [] })
    if (val) {
      this.fetchProjectElements(val.id)
      this.updateUrl(filters)
      this.fetchData(filters)
    } else {
      this.setState({ data: [] })
      this.props.history.replace(this.props.history.location.pathname)
    }
  }

  renderRows() {
    const { data } = this.state
    const { InspectionCategoryTypes } = this.props

    return data.map(welder => {
      const inspectionsMap = {}
      welder.inspection_categories.forEach(cat => {
        inspectionsMap[cat.inspection_category_type_id] = {
          failed: cat.total_failed,
          complete: cat.total_complete
        }
      })

      return (
        <tr key={welder.person_id}>
          <td><b>{welder.welder_name}</b></td>
          <td>{welder.welding_length}</td>
          <td>{welder.total_failed}</td>
          <td>{welder.total_failed === 0 ? '0%' : `${countPercent(welder.total_complete, welder.total_failed)}%`}</td>
          <InspectionTableData inspectionCategoryTypes={InspectionCategoryTypes} inspectionsData={inspectionsMap} />
        </tr>
      )
    })
  }

  render() {
    const { filters, loading, projectElements, welders_list } = this.state
    const { ProjectsList, InspectionCategoryTypes } = this.props

    return (
      <BlockWithLoader loading={loading} renderChildren={true}>
        <Card>
          <CardHeader>
            <AvForm id="welder-defectiveness-form" className="FormClassLabel">
              <Row>
                <Col xs="12" sm="4">
                  <CreatableSelect
                    label="Select welder(s)"
                    id="welder-defectiveness-select"
                    valueKey="id"
                    options={welders_list}
                    value={filters.welder_ids || []}
                    multi={true}
                    creatable={false}
                    valueChangeFunction={(val) => {
                      const ids = val ? (Array.isArray(val) ? val.map(v => v.id) : [val.id]) : []
                      this.setFilter({ welder_ids: ids })
                    }}
                  />
                </Col>
                <Col xs="12" sm="4">
                  <CreatableSelect
                    label="Select project"
                    id="project-defectiveness-select"
                    valueKey="id"
                    options={ProjectsList}
                    value={filters.project_id || null}
                    multi={false}
                    creatable={false}
                    valueChangeFunction={this.handleProjectChange}
                  />
                </Col>
                <Col xs="12" sm="4">
                  <CreatableSelect
                    label="Elements (multi)"
                    id="element-defectiveness-select"
                    options={projectElements}
                    valueKey="id"
                    value={filters.element_ids || []}
                    multi={true}
                    creatable={false}
                    valueChangeFunction={(val) => {
                      const ids = val ? (Array.isArray(val) ? val.map(v => v.id) : [val.id]) : []
                      this.setFilter({ element_ids: ids })
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="2">
                  <FormGroup>
                    <Label>Date type</Label>
                    <Input type="select" value={filters.date_type || 'welding'} onChange={e => this.setFilter({ date_type: e.target.value })}>
                      <option value="welding">Welding</option>
                      <option value="inspection">Inspection</option>
                      <option value="welding_log_create">Welding Log Create</option>
                      <option value="inspection_log_create">Inspection Log Create</option>
                    </Input>
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2">
                  <FormGroup>
                    <Label>Date from</Label>
                    <Input type="date" value={filters.date_from || ''} max={filters.date_to}
                      onChange={e => this.setFilter({ date_from: e.target.value || undefined })} />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2">
                  <FormGroup>
                    <Label>Date to</Label>
                    <Input type="date" value={filters.date_to || ''} min={filters.date_from}
                      onChange={e => this.setFilter({ date_to: e.target.value || undefined })} />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2">
                  <ButtonGroup style={{ marginTop: '29px' }}>
                    <Button color="secondary" onClick={this.handleClearFilters}>
                      <i className="fa fa-eraser" /> Clear
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </AvForm>
          </CardHeader>
          <CardBody>
            <Table bordered striped responsive className="table-center table-sticky-first-col" id="welder-defectiveness-table">
              <thead>
                <tr>
                  <th />
                  <th rowSpan={2}>Welding length [mm]</th>
                  <th rowSpan={2}>Failed [mm]</th>
                  <th rowSpan={2}>Failed [%]</th>
                  {InspectionCategoryTypes.map(t => <th colSpan={3} key={t.id}>{t.name}</th>)}
                </tr>
                <tr>
                  <th>Welder name</th>
                  <InspectionTableHeaders inspectionCategoryTypes={InspectionCategoryTypes} />
                </tr>
              </thead>
              <tbody>
                {this.renderRows()}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </BlockWithLoader>
    )
  }
}

export default withApollo(WelderDefectiveness)



// WEBPACK FOOTER //
// ./src/components/Report/WelderDefectiveness.js